export const MAX_LENGTH_PO = 35;
